import React from 'react'
import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import Header from '../../Header'
import Footer from '../../Footer'
import { setUIForwardAction, setUIBackwardsAction, isTruckTrailer } from '../../../actions'
import { updateReservationAndGoHomeAction } from '../../../actions/reservation'
import { UI } from '../../../constants/ui'
import './moreThanOnePassenger.less'
import { AppState } from '../../../reducers'
import { USERNOTE_MORE_THAN_ONE_PASSENGER } from '../../../constants/userNote'
import { isELConnectionHideSelector } from '../../../reducers/terminal'
import onePassengerImg from '../../../assets/onePassenger.png'
import twoPassengersImg from '../../../assets/twoPassengers.png'
import threePassengersImg from '../../../assets/threePassengers.png'
import FooterMobile from '../../FooterMobile'
import { getMode } from '../../../hooks/mode'
import { MODE } from '../../../constants/mode'

interface MobileAndDesktopProps {
  back: () => void
  onClick: (count: number) => void
}

const MoreThanOnePassengerMobile: React.FC<MobileAndDesktopProps> = ({ back, onClick }) => {
  const { t } = useTranslation()
  return (
    <div className="more-than-one-passenger-mobile">
      <div className="more-than-one-passenger-mobile-wrapper">
        <div className="more-than-one-passenger-title" dangerouslySetInnerHTML={{ __html: t('howManyPassengers') }}></div>
        <div className="more-than-one-passenger-buttons">
          <button className="main-button-mobile passenger-button" onClick={() => onClick(1)}>
            <div className="passenger-button-container">
              <div className="passenger-button-image">
                <img className="passenger-image" src={onePassengerImg} alt="one passenger" />
              </div>
              <div className="passenger-button-text">{t('onePassenger')}</div>
            </div>
          </button>
          <button className="main-button-mobile passenger-button" onClick={() => onClick(2)}>
            <div className="passenger-button-container">
              <div className="passenger-button-image">
                <img className="passenger-image" src={twoPassengersImg} alt="two passengers" />
              </div>
              <div className="passenger-button-text">{t('twoPassengers')}</div>
            </div>
          </button>
          <button className="main-button-mobile passenger-button" onClick={() => onClick(3)}>
            <div className="passenger-button-container">
              <div className="passenger-button-image">
                <img className="passenger-image" src={threePassengersImg} alt="three passengers" />
              </div>
              <div className="passenger-button-text">{t('threePassengers')}</div>
            </div>
          </button>
        </div>
      </div>
      <div className="footer-mobile-container">
        <FooterMobile showPageCount back={back} />
      </div>
    </div>
  )
}

const MoreThanOnePassengerDesktop: React.FC<MobileAndDesktopProps> = ({ back, onClick }) => {
  const { t } = useTranslation()
  return (
    <>
      <Header showPageCount back={back} />
      <div className="more-than-one-passenger">
        <div className="more-than-one-passenger-title" dangerouslySetInnerHTML={{ __html: t('howManyPassengers') }}></div>
        <div className="more-than-one-passenger-buttons">
          <button className="main-button passenger-button" onClick={() => onClick(1)}>
            <div className="passenger-button-container">
              <div className="passenger-button-image">
                <img className="passenger-image" src={onePassengerImg} alt="one passenger" />
              </div>
              <div className="passenger-button-text">{t('onePassenger')}</div>
            </div>
          </button>
          <button className="main-button passenger-button" onClick={() => onClick(2)}>
            <div className="passenger-button-container">
              <div className="passenger-button-image">
                <img className="passenger-image" src={twoPassengersImg} alt="two passengers" />
              </div>
              <div className="passenger-button-text">{t('twoPassengers')}</div>
            </div>
          </button>
          <button className="main-button passenger-button" onClick={() => onClick(3)}>
            <div className="passenger-button-container">
              <div className="passenger-button-image">
                <img className="passenger-image" src={threePassengersImg} alt="three passengers" />
              </div>
              <div className="passenger-button-text">{t('threePassengers')}</div>
            </div>
          </button>
        </div>
      </div>
      <Footer />
    </>
  )
}

const mapStateToProps = (state: AppState) => ({
  reservation: state.reservation.reservation,
  reservationChange: state.reservationChange,
  isELConnectionHidden: isELConnectionHideSelector(state),
})

const mapDispatchToProps = {
  setUIForward: setUIForwardAction,
  setUIBackwards: setUIBackwardsAction,
  updateReservationAndGoHome: updateReservationAndGoHomeAction,
}

type StateProps = ReturnType<typeof mapStateToProps>
type DispatchProps = typeof mapDispatchToProps
type Props = StateProps & DispatchProps

const MoreThanOnePassenger: React.FC<Props> = ({
  setUIForward,
  setUIBackwards,
  reservation,
  reservationChange,
  updateReservationAndGoHome,
  isELConnectionHidden,
}: Props) => {
  const mode = getMode()
  if (!reservation) {
    return null
  }

  const back = () => {
    if (isELConnectionHidden) {
      setUIBackwards(UI.DANGEROUS_GOODS)
    } else {
      setUIBackwards(UI.CONFIRM_CONNECTION)
    }
  }

  const onClick = (passengersCount: number) => {
    if (passengersCount > 2 || reservation.drivers.length !== passengersCount) {
      updateReservationAndGoHome(USERNOTE_MORE_THAN_ONE_PASSENGER)
      return
    }
    if (isTruckTrailer(reservationChange)) {
      setUIForward(UI.TRAILER)
    } else {
      setUIForward(UI.CARGO_LENGTH)
    }
  }

  if (mode === MODE.MOBILE) {
    return <MoreThanOnePassengerMobile back={back} onClick={onClick} />
  } else {
    return <MoreThanOnePassengerDesktop back={back} onClick={onClick} />
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(MoreThanOnePassenger)
